<div class="logo-box">
  <img width="300px" src="/assets/svg/Variant2.svg" />
</div>
